<template>
  <div v-if="post" class="frisbuy-popup-overlay" @click.self="popupClose">
    <div v-if="true" class="frisbuy-popup-controls" :class="{'frisbuy-popup-controls-no-navigation': postList.length == 1}">
      <div class="frisbuy-popup-navigation" v-if="postList.length > 1">
        <div class="frisbuy-popup-control frisbuy-prev" @click="popupPrev">
            <svg viewBox="0 0 24 43">
                <path d="M21,0.976190476 L0.923190379,20.5749808" id="Line"></path>
                <path d="M21,20.5 L0.923190379,40.0987903" id="Line" transform="translate(11.000000, 30.261905) scale(1, -1) translate(-11.000000, -30.261905) "></path>
            </svg>
        </div>
        <div class="frisbuy-popup-control frisbuy-next" @click="popupNext">
            <svg viewBox="0 0 24 43">
                <path d="M21,0.976190476 L0.923190379,20.5749808" id="Line"></path>
                <path d="M21,20.5 L0.923190379,40.0987903" id="Line" transform="translate(11.000000, 30.261905) scale(1, -1) translate(-11.000000, -30.261905) "></path>
            </svg>
        </div>
      </div>
      <!-- <div class="frisbuy-popup-control frisbuy-close" @click="popupClose">
          <svg viewBox="0 0 26 26">
              <path d="M22.8863702,1.11362984 L0.52753736,23.4724626" id="Line" transform="translate(12.000000, 12.000000) scale(1, -1) translate(-12.000000, -12.000000) "></path>
              <path d="M22.8863702,1.11362984 L0.52753736,23.4724626" id="Line" transform="translate(12.000000, 12.000000) scale(-1, -1) translate(-12.000000, -12.000000) "></path>
          </svg>
      </div> -->
    </div>

    <div :class="{
      'frisbuy-popup': true,
      'frisbuy-scroller': true,
      'frisbuy-complain-show': showComplainForm,
      'frisbuy-has-share': popupSettings.shareButtons.enable}"
      >
      <button class="frisbuy-popup-close-button" @click="popupClose">
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M27.1882 16.8115L16.8115 27.1882" stroke="#131313" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M27.1882 27.1882L16.8115 16.8115" stroke="#131313" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M22 38.5C12.8865 38.5 5.5 31.1135 5.5 22C5.5 12.8865 12.8865 5.5 22 5.5C31.1135 5.5 38.5 12.8865 38.5 22C38.5 31.1135 31.1135 38.5 22 38.5Z" stroke="#131313" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <div v-touch:swipe="swipeHandler" class="frisbuy-content-wrapper frisbuy-scroller" ref="scrollWrapper" :style="swipeStyle">
        <div class="frisbuy-popup-content">
          <div class="frisbuy-popup-media">
            <div v-if="popupSettings.showReportButton && !isPlaying" class="frisbuy-complain-button" @click="showComplainForm = true">
              <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.79753 0.0286079C5.53223 0.0911624 5.27861 0.271445 5.08505 0.535087C5.00335 0.646357 0.986797 7.36038 0.301285 8.53157C0.0909552 8.89089 0.0188286 9.08942 0.0039888 9.34978C-0.00589645 9.52317 0.000796937 9.58208 0.0445541 9.7073C0.182852 10.103 0.531671 10.3225 1.1058 10.3752C1.46515 10.4083 10.5349 10.4083 10.8942 10.3752C11.4683 10.3225 11.8171 10.103 11.9554 9.7073C11.9992 9.58208 12.0059 9.52317 11.996 9.34978C11.9812 9.08942 11.909 8.89089 11.6987 8.53157C11.0132 7.36038 6.99665 0.646357 6.91495 0.535087C6.71488 0.262565 6.44843 0.0787991 6.17153 0.022334C6.0181 -0.00894327 5.9521 -0.00783608 5.79753 0.0286079ZM6.31235 2.75388C6.61243 2.85641 6.8275 3.12174 6.88353 3.4585C6.90887 3.61101 6.88834 3.79067 6.76245 4.51749C6.64688 5.1847 6.52899 5.93999 6.48886 6.2705C6.46804 6.44176 6.44553 6.61561 6.43881 6.65685L6.42659 6.73181H6.002H5.57739L5.56071 6.54152C5.52477 6.13169 5.39862 5.34 5.16468 4.05618C5.10028 3.70272 5.09399 3.63197 5.11412 3.48728C5.1699 3.08651 5.45214 2.78207 5.82688 2.71843C5.9616 2.69557 6.19058 2.71227 6.31235 2.75388ZM6.36921 7.33033C6.52399 7.40372 6.7291 7.59208 6.79835 7.72436C6.88631 7.89249 6.91766 8.09327 6.88376 8.27148C6.868 8.35426 6.83324 8.46353 6.80652 8.51427C6.73098 8.6576 6.5419 8.82513 6.3653 8.90517C6.22626 8.96816 6.18182 8.97688 6 8.97688C5.81818 8.97688 5.77374 8.96816 5.6347 8.90517C5.459 8.82554 5.26909 8.65774 5.19455 8.51628C5.1135 8.36245 5.08324 8.15657 5.11619 7.98334C5.15375 7.78599 5.23155 7.64377 5.37278 7.51434C5.59973 7.30631 5.71804 7.26166 6.02382 7.26867C6.2085 7.27291 6.27202 7.28424 6.36921 7.33033Z" fill="white"/>
              </svg>
              {{ popupText.complain }}
            </div>

            <div class="frisbuy-complain-form" :class="{'frisbuy-complain-message': complainSended}" v-if="showComplainForm" @touchemove.stop>
              <template v-if="complainSended">
                <div class="frisbuy-complain-form__title">{{ popupText.complainAccepted }}<br/> {{ popupText.afterAccept }}</div>
                <div class="frisbuy-complain-form__buttons">
                  <button @click="showComplainForm = false">{{ popupText.ok }}</button>
                </div>
              </template>
              <template v-else>
                <div class="frisbuy-complain-form__title">{{ popupText.confirm }}</div>
                <div class="frisbuy-complain-form__note">{{ popupText.complainNote }}</div>
                <div class="frisbuy-complain-form__email">
                  <label>E-Mail*</label>
                  <input type="email" @input="complainError = null" v-model="email">
                </div>
                <div class="frisbuy-complain-form__text">
                  <label>{{ popupText.complainText }}</label>
                  <textarea cols="30" rows="5" v-model="complainText" @input="complainError = null"></textarea>
                </div>
                <div class="frisbuy-complain-form__buttons">
                  <button @click="showComplainForm = false" :disabled="inSending">{{ popupText.cancel }}</button>
                  <button :class="{'frisbuy-button-loading': inSending}" @click="sendComplain" :disabled="inSending">{{ popupText.submit }}</button>
                </div>
                <div class="frisbuy-complain-form__error" v-if="complainError">
                  {{complainError}}
                </div>
              </template>

            </div>

            <post-image :media="currentMedia" :post="post" v-if="!isPlaying || !mediaIsVideo" :settings="settings" ref="postImage"></post-image>

            <div class="frisbuy-media-play" v-if="currentMedia.videoUrl && !isPlaying" @click="isPlaying = true">
              <img :src="`${envDomain}/images/widget/play.svg`">
            </div>

            <div :class="{ 'frisbuy-video-wrapper': isPlaying }" v-if="currentMedia.videoUrl" >
              <video
                v-show="isPlaying"
                :controls="isPlaying"
                loop="true"
                controlsList="nodownload"
                :autoplay="popupSettings.autoplayVideo"
                @loadeddata="videoLoaded"
                ref="video"
                @pause="pauseVideo"
                playsinline
              >
                <source @error="errorVideoHandler" type="video/mp4" />
              </video>
            </div>

            <div class="frisbuy-gallery-navigation" v-if="isMultiPosts">
              <div class="frisbuy-navigation-button" v-if="mediaIndex" @click="navigate(mediaIndex - 1)">
                <svg version="1.1" viewBox="0 0 24 32" xml:space="preserve">
                  <polyline stroke="currentColor" fill="none" points="16,24 8,16 16,8"/>
                </svg>
              </div>
              <span></span>
              <div class="frisbuy-navigation-button" v-if="mediaIndex !== post.media.length - 1" @click="navigate(mediaIndex + 1)">
                <svg version="1.1" viewBox="0 0 24 32" xml:space="preserve">
                  <polyline stroke="currentColor" fill="none" points="8,8 16,16 8,24"/>
                </svg>
              </div>
            </div>

          </div>

          <frisbuy-gallery-pagination v-if="isMultiPosts"
            :itemsCount="post.media.length"
            :currentItemIdx="mediaIndex"
            @navigateTo="(idx) => navigate(idx)"
          />
        </div>

        <div class="frisbuy-popup-details" :class="{'frisbuy-details-no-post-text': !post.frisbuyPost.text}">
          <div class="frisbuy-post-details">
            <div class="frisbuy-brand" :style="{'background-image': `url(${ post.instagramPost.authorUser.avatarUrl })`}"></div>
            <a
              :href="popupSettings.enableAuthorLink ? post.instagramPost.postLink : undefined"
              target="_blank"
            >
              {{ post.instagramPost.authorUser.fio || `@${post.instagramPost.authorUser.username}` }}
            </a>
          </div>

          <div v-if="popupSettings.shareButtons.enable" class="frisbuy-social-buttons">
            <a
              v-if="popupSettings.shareButtons.vk.isEnabled && !settings.isOwnerShopifyUser"
              @click="shareClick('vk')"
              class="frisbuy-social-button"
              target="_blank"
              :href="popupSettings.shareButtons.vk.customLink || `https://vk.com/share.php?url=${ shareUrl('vk') }&title=${ encodedDescription }&image=${currentMedia.imageHighResolutionUrl}&noparse=true`"
            >
              <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.2824 2.23393e-05C18.7077 2.60202 17.1856 4.54112 14.9125 5.98224C14.9181 6.00811 14.9518 6.01134 14.9765 6.02319C16.9386 6.98682 18.3866 8.43548 19.3655 10.325C19.6192 10.8241 19.8272 11.3435 19.9873 11.8771C20.0176 11.9752 19.9963 11.9957 19.893 11.9957C18.8005 11.9957 17.7087 11.9957 16.6176 11.9957C16.5949 11.9991 16.5718 11.9981 16.5496 11.9929C16.5273 11.9877 16.5064 11.9783 16.4879 11.9653C16.4695 11.9522 16.4539 11.9359 16.442 11.917C16.4302 11.8982 16.4223 11.8773 16.4189 11.8556C16.0352 10.7345 15.3359 9.73734 14.3984 8.97442C13.5431 8.27486 12.4905 7.83549 11.3744 7.71223C11.2733 7.70037 11.2879 7.75319 11.2879 7.80924V9.28485C11.2879 10.1418 11.2879 10.9976 11.2879 11.8534C11.2879 11.9612 11.2688 11.9957 11.1487 11.9957C9.91448 12.0209 8.68286 11.8757 7.4916 11.5646C4.9974 10.8758 3.11383 9.43791 1.82632 7.27892C1.09669 6.05661 0.643196 4.73729 0.359202 3.36084C0.14428 2.2965 0.0241124 1.21652 0 0.132599C0 0.0248114 0.0258184 0.00109798 0.135824 0.00109798C1.1835 0.00540949 2.23341 0.00540949 3.28558 0.00109798C3.39783 0.00109798 3.42813 0.0237347 3.43038 0.130444C3.44053 0.862301 3.50883 1.59235 3.63467 2.31422C3.87938 3.71546 4.31716 5.04987 5.16914 6.23015C5.75846 7.04826 6.4937 7.70684 7.45344 8.11104C7.56569 8.16063 7.69366 8.20051 7.81489 8.24147C7.88897 8.26626 7.9653 8.28566 8.06071 8.31261V8.15416C8.06071 5.48534 8.06071 2.81651 8.06071 0.147691C8.06071 0.0215794 8.09776 2.01025e-05 8.21787 0.00109798C9.20118 0.00540949 10.1849 0.00540949 11.1689 0.00109798C11.2677 0.00109798 11.2913 0.0269687 11.2913 0.120744C11.2913 1.60462 11.2913 3.08886 11.2913 4.57345C11.2913 4.75346 11.2913 4.75238 11.4844 4.71897C12.1621 4.59285 12.7968 4.30772 13.332 3.889C14.6296 2.91891 15.4917 1.65456 15.9901 0.157391C16.0305 0.0366692 16.0777 -0.00105554 16.2146 2.23393e-05C17.1811 0.0064896 18.1476 2.23393e-05 19.114 2.23393e-05H19.2824Z" fill="#A9A9AE"/>
              </svg>
            </a>
            <a
              class="frisbuy-social-button"
              :class="{ 'frisbuy-tooltip': linkCopied }"
              @click="copyLinkToClipboard"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 3H5C3.895 3 3 3.895 3 5V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V14" stroke="#A9A9AE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9999 9.792C12.7569 9.792 10.0009 11.46 8.94092 13.795V13.203C8.94092 8.956 12.0619 5.492 15.9999 5.233V2L21.9999 7.5L15.9999 13V9.792Z" stroke="#A9A9AE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
          </div>

          <div class="frisbuy-details-scroller frisbuy-scroller" ref="scrollDetails">
            <div :class="{'frisbuy-products-list': true, 'frisbuy-products-inline': !showSkuPics, 'frisbuy-has-link': hasLink }">
              <a
                v-for="(link, index) in currentMedia.linkList"
                class="frisbuy-product-item"
                @click="linkClick($event, link, index)"
                :href="!hideBuyButton(link) && link.link"
                :target="Boolean(popupSettings.targetBlankLink) ? '_blank' : '_self'"
                @mouseenter="mouseOver(link, true)"
                @mouseleave="mouseOver(link, false)"
              >
                <div v-if="showUnpinnedNumbers" :class="{'frisbuy-marker': true, 'frisbuy-marker-hover': link.hover }" :style="{ color: popupSettings.image.numberColor }">
                  <span>{{index+1}}</span>
                </div>

                <div class="frisbuy-product-image" :style="{'background-image': `url(${ link.sku.thumbUrl })`}">
                  <div class="frisbuy-similar-title" v-if="link.isSimilar">{{ popupText.similarGood }}</div>
                </div>

                <span class="frisbuy-product-title">
                  {{link.title}}
                </span>

                <div v-if="link.sku.price" class="frisbuy-product-price">
                  <span :class="{ 'frisbuy-has-discount': link.sku.priceOld }">
                    {{link.sku.price}} {{link.sku.currencySymbol || popupSettings.currencySymbol || ""}}
                    <svg v-if="!popupSettings.currencySymbol && !link.sku.currencySymbol" viewBox="0 0 510.127 510.127">
                      <path fill="currentColor"
                        d="M34.786 428.963h81.158v69.572c0 3.385 1.083 6.156 3.262 8.322 2.173 2.18 4.95 3.27 8.335 3.27h60.503c3.14 0 5.857-1.09 8.152-3.27 2.295-2.166 3.44-4.938 3.44-8.322v-69.572h182.963c3.377 0 6.156-1.076 8.334-3.256 2.18-2.178 3.262-4.95 3.262-8.336v-46.376c0-3.365-1.082-6.156-3.262-8.322-2.172-2.18-4.957-3.27-8.334-3.27h-182.97v-42.754h123.184c48.305 0 87.73-14.72 118.293-44.2 30.55-29.448 45.834-67.49 45.834-114.124 0-46.604-15.284-84.646-45.835-114.125C410.548 14.75 371.115 0 322.812 0H127.535c-3.385 0-6.157 1.09-8.335 3.256-2.173 2.18-3.262 4.97-3.262 8.335v227.897H34.786c-3.384 0-6.157 1.145-8.335 3.44-2.17 2.294-3.26 5.01-3.26 8.15v53.978c0 3.385 1.082 6.158 3.26 8.336 2.18 2.18 4.946 3.257 8.336 3.257h81.158V359.4H34.786c-3.384 0-6.157 1.09-8.335 3.27-2.17 2.167-3.26 4.952-3.26 8.323v46.377c0 3.385 1.082 6.158 3.26 8.336 2.18 2.18 4.95 3.257 8.336 3.257zM199.628 77.18h115.938c25.6 0 46.248 7.484 61.953 22.46 15.696 14.975 23.548 34.546 23.548 58.69 0 24.156-7.852 43.733-23.55 58.69-15.704 14.99-36.353 22.474-61.952 22.474H199.628V77.18z" />
                    </svg>
                  </span>

                  <span class="frisbuy-price-old" v-if="link.sku.priceOld">
                    {{link.sku.priceOld}} {{link.sku.currencySymbol || popupSettings.currencySymbol || ""}}
                    <svg v-if="!popupSettings.currencySymbol && !link.sku.currencySymbol" viewBox="0 0 510.127 510.127">
                      <path fill="currentColor"
                        d="M34.786 428.963h81.158v69.572c0 3.385 1.083 6.156 3.262 8.322 2.173 2.18 4.95 3.27 8.335 3.27h60.503c3.14 0 5.857-1.09 8.152-3.27 2.295-2.166 3.44-4.938 3.44-8.322v-69.572h182.963c3.377 0 6.156-1.076 8.334-3.256 2.18-2.178 3.262-4.95 3.262-8.336v-46.376c0-3.365-1.082-6.156-3.262-8.322-2.172-2.18-4.957-3.27-8.334-3.27h-182.97v-42.754h123.184c48.305 0 87.73-14.72 118.293-44.2 30.55-29.448 45.834-67.49 45.834-114.124 0-46.604-15.284-84.646-45.835-114.125C410.548 14.75 371.115 0 322.812 0H127.535c-3.385 0-6.157 1.09-8.335 3.256-2.173 2.18-3.262 4.97-3.262 8.335v227.897H34.786c-3.384 0-6.157 1.145-8.335 3.44-2.17 2.294-3.26 5.01-3.26 8.15v53.978c0 3.385 1.082 6.158 3.26 8.336 2.18 2.18 4.946 3.257 8.336 3.257h81.158V359.4H34.786c-3.384 0-6.157 1.09-8.335 3.27-2.17 2.167-3.26 4.952-3.26 8.323v46.377c0 3.385 1.082 6.158 3.26 8.336 2.18 2.18 4.95 3.257 8.336 3.257zM199.628 77.18h115.938c25.6 0 46.248 7.484 61.953 22.46 15.696 14.975 23.548 34.546 23.548 58.69 0 24.156-7.852 43.733-23.55 58.69-15.704 14.99-36.353 22.474-61.952 22.474H199.628V77.18z" />
                    </svg>
                  </span>
                </div>

                <button>{{buttonText(link)}}</button>
              </a>
            </div>

            <div class="frisbuy-similar" v-if="currentMedia.similarGoods && currentMedia.similarGoods.length">
              <div class="frisbuy-similar-title">{{ popupText.similarGoods }}</div>
              <div class="frisbuy-products-wrapper">
                <div class="frisbuy-gallery-navigation" >
                  <div class="frisbuy-navigation-button" v-if="canPrevProduct" @click="navigateProducts(-1)">
                    <svg version="1.1" viewBox="0 0 24 32" xml:space="preserve">
                      <polyline stroke="currentColor" fill="none" points="16,24 8,16 16,8"/>
                    </svg>
                  </div>
                  <span></span>
                  <div class="frisbuy-navigation-button" v-if="canNextProduct" @click="navigateProducts(1)">
                    <svg version="1.1" viewBox="0 0 24 32" xml:space="preserve">
                      <polyline stroke="currentColor" fill="none" points="8,8 16,16 8,24"/>
                    </svg>
                  </div>
                </div>
                <div class="frisbuy-products-list" ref="productList" @scroll="productsScrollHandler">
                  <a
                    v-for="(link, index) in currentMedia.similarGoods"
                    class="frisbuy-product-item"
                    @click="similarLinkClick($event, link, index)"
                    :href="link.vendorShopUrl"
                    :target="Boolean(popupSettings.targetBlankLink) ? '_blank' : '_self'"
                  >
                    <div class="frisbuy-product-image" :style="{'background-image': `url(${ link.imageUrl })`}">
                    </div>
                    <div
                      v-if="link.price"
                      class="frisbuy-product-price"
                      :class="{'frisbuy-no-discount': !link.priceOld}"
                    >
                      <span>
                        {{link.price}} {{popupSettings.currencySymbol || ""}}
                        <svg v-if="!popupSettings.currencySymbol" viewBox="0 0 510.127 510.127">
                          <path fill="currentColor" d="M34.786 428.963h81.158v69.572c0 3.385 1.083 6.156 3.262 8.322 2.173 2.18 4.95 3.27 8.335 3.27h60.503c3.14 0 5.857-1.09 8.152-3.27 2.295-2.166 3.44-4.938 3.44-8.322v-69.572h182.963c3.377 0 6.156-1.076 8.334-3.256 2.18-2.178 3.262-4.95 3.262-8.336v-46.376c0-3.365-1.082-6.156-3.262-8.322-2.172-2.18-4.957-3.27-8.334-3.27h-182.97v-42.754h123.184c48.305 0 87.73-14.72 118.293-44.2 30.55-29.448 45.834-67.49 45.834-114.124 0-46.604-15.284-84.646-45.835-114.125C410.548 14.75 371.115 0 322.812 0H127.535c-3.385 0-6.157 1.09-8.335 3.256-2.173 2.18-3.262 4.97-3.262 8.335v227.897H34.786c-3.384 0-6.157 1.145-8.335 3.44-2.17 2.294-3.26 5.01-3.26 8.15v53.978c0 3.385 1.082 6.158 3.26 8.336 2.18 2.18 4.946 3.257 8.336 3.257h81.158V359.4H34.786c-3.384 0-6.157 1.09-8.335 3.27-2.17 2.167-3.26 4.952-3.26 8.323v46.377c0 3.385 1.082 6.158 3.26 8.336 2.18 2.18 4.95 3.257 8.336 3.257zM199.628 77.18h115.938c25.6 0 46.248 7.484 61.953 22.46 15.696 14.975 23.548 34.546 23.548 58.69 0 24.156-7.852 43.733-23.55 58.69-15.704 14.99-36.353 22.474-61.952 22.474H199.628V77.18z"/>
                        </svg>
                      </span>
                      
                      <span v-if="link.priceOld" class="frisbuy-price-old">
                        {{link.priceOld}} {{popupSettings.currencySymbol || ""}}
                        <svg v-if="!popupSettings.currencySymbol" viewBox="0 0 510.127 510.127">
                          <path fill="currentColor" d="M34.786 428.963h81.158v69.572c0 3.385 1.083 6.156 3.262 8.322 2.173 2.18 4.95 3.27 8.335 3.27h60.503c3.14 0 5.857-1.09 8.152-3.27 2.295-2.166 3.44-4.938 3.44-8.322v-69.572h182.963c3.377 0 6.156-1.076 8.334-3.256 2.18-2.178 3.262-4.95 3.262-8.336v-46.376c0-3.365-1.082-6.156-3.262-8.322-2.172-2.18-4.957-3.27-8.334-3.27h-182.97v-42.754h123.184c48.305 0 87.73-14.72 118.293-44.2 30.55-29.448 45.834-67.49 45.834-114.124 0-46.604-15.284-84.646-45.835-114.125C410.548 14.75 371.115 0 322.812 0H127.535c-3.385 0-6.157 1.09-8.335 3.256-2.173 2.18-3.262 4.97-3.262 8.335v227.897H34.786c-3.384 0-6.157 1.145-8.335 3.44-2.17 2.294-3.26 5.01-3.26 8.15v53.978c0 3.385 1.082 6.158 3.26 8.336 2.18 2.18 4.946 3.257 8.336 3.257h81.158V359.4H34.786c-3.384 0-6.157 1.09-8.335 3.27-2.17 2.167-3.26 4.952-3.26 8.323v46.377c0 3.385 1.082 6.158 3.26 8.336 2.18 2.18 4.95 3.257 8.336 3.257zM199.628 77.18h115.938c25.6 0 46.248 7.484 61.953 22.46 15.696 14.975 23.548 34.546 23.548 58.69 0 24.156-7.852 43.733-23.55 58.69-15.704 14.99-36.353 22.474-61.952 22.474H199.628V77.18z"/>
                        </svg>
                      </span>
                    </div>

                    <span>
                      {{link.name}}
                    </span>
                    <button>{{popupSettings.skuLinkText || popupText.buy }}</button>
                  </a>
                </div>
              </div>
            </div>

            <hr class="frisbuy-post-divider" />

            <div class="frisbuy-post-text" v-html="tageted(post.frisbuyPost.text)"></div>
            <div class="frisbuy-comments" v-if="post.instagramPost.commentList && post.instagramPost.commentList.length">
              <div v-for="commment in post.instagramPost.commentList">
                <strong>{{commment.author.username}}</strong> <span v-html="tageted(commment.text)"></span>
              </div>
              <a>{{ popupText.loadMoreComments }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import defaultPopup from "@/gallery/popup/popup.vue";

export default {
  mixins: [defaultPopup],
}
</script>
